"use client";

import { Box, Heading, Stack } from "@biom3/react";
import { useState } from "react";

import { NameWalletModal } from "@/components/wallets/NameWalletModal";
import { UnlinkWalletModal } from "@/components/wallets/UnlinkWalletModal";
import type { Wallet } from "@/types";

import { analytics } from "@analytics";
import { LinkedWalletItem } from "./LinkedWalletItem";

const LinkedWallets = ({ wallets = [] }: { wallets?: Wallet[] }) => {
  const [isUnlinkModalOpen, setIsUnlinkModalOpen] = useState(false);
  const [isNameWalletModalOpen, setIsNameWalletModalOpen] = useState(false);
  const [currentWallet, setCurrentWallet] = useState<Wallet | null>(null);

  const onNicknameOpenModal = (wallet: Wallet) => {
    analytics.track("PassportDashboardWalletsNicknameModal_ClickButtonOpened");
    setIsNameWalletModalOpen(true);
    setCurrentWallet(wallet);
  };

  const onUnlinkOpenModal = (wallet: Wallet) => {
    analytics.track("PassportDashboardWalletsUnlinkModal_ClickButtonOpened");
    setIsUnlinkModalOpen(true);
    setCurrentWallet(wallet);
  };

  if (!wallets.length) {
    return <></>;
  }

  return (
    <Box>
      <Heading
        testId="linked-wallets-heading"
        size="xSmall"
        sx={{ my: "base.spacing.x4" }}
      >
        Linked wallets
      </Heading>
      <Stack gap="base.spacing.x2">
        {wallets.map((wallet) => (
          <LinkedWalletItem
            wallet={wallet}
            key={wallet.address}
            onUnlinkOpenModal={onUnlinkOpenModal}
            onNicknameOpenModal={onNicknameOpenModal}
          />
        ))}
      </Stack>
      <NameWalletModal
        linkedWallets={wallets}
        wallet={currentWallet}
        isModalOpen={isNameWalletModalOpen}
        setIsModalOpen={setIsNameWalletModalOpen}
      />
      <UnlinkWalletModal
        isModalOpen={isUnlinkModalOpen}
        wallet={currentWallet}
        setIsModalOpen={setIsUnlinkModalOpen}
      />
    </Box>
  );
};

export { LinkedWallets };
